// extracted by mini-css-extract-plugin
export default {"thumbnailsContainer":"bookingThumbnails_thumbnailsContainer__3KkUt"};